import React, { Component } from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router-dom'
import PrivateNavBarClients from '../nav-bar/PrivateNavBarClients'
import ActivityRegister from "../activity-log/activity/ActivityRegister";
import BigFooter from '../footer/BigFooter'

export class ActivityLogInit extends Component {
  render() {
    return (
      <>
        <PrivateNavBarClients showSearchLog={false} />
        <div className='container' style={{ marginTop: "90px" }}>  
            <ActivityRegister />              
          <BigFooter />
        </div>        
      </>
    )
  }
}

const mapStateToProps = state => {
  return {
  }
}

const mapDispatchToProps = {

}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(ActivityLogInit)))
